import React, { Component } from 'react';
import qs from 'qs';
import Titulo from '../comum/Titulo';
import buscarVeiculo from '../../actions/veiculo/buscarVeiculo';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import Autorizacao from '../../security/Autorizacao';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes } from '../../security/securityContext';
import 'moment/locale/pt-br'
import moment from 'moment';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';
import { renderField } from '../../util/inputs';
import { maxTamanhoCampoTipoOcorrencia, maxValueMonetario, renderFieldMonetarioLabelEncima, renderTextArea, required } from '../../util/inputs';
import cadastrarManutencaoVeiculo from '../../actions/manutencao-veiculo/cadastrar-manutencao-veiculo';
import buscarRegistrosManutencaoVeiculo from '../../actions/manutencao-veiculo/buscar-registros-manutencao-veiculo';
import { showSuccessMsg } from '../../util/messagesUtil';
import ManutencaoVeiculo from './ManutencaoVeiculo';
import Moment from 'react-moment';
import selecionaManutencaoVeiculo from '../../actions/manutencao-veiculo/seleciona-manutencao-veiculo';
import atualizarManutencaoVeiculo from '../../actions/manutencao-veiculo/atualizar-manutencao-veiculo';
import excluirManutencaoVeiculo from '../../actions/manutencao-veiculo/excluir-manutencao-veiculo';
import PainelFiltragem from './PainelFiltrosManutencaoVeiculo';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro } from '../../util/filtros';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export const validate = (values) => {
    const errors = {};
    if (!values.tipoOcorrencia) errors.tipoOcorrencia = 'Campo obrigatório';
    return errors;
};

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const ModalConfirmacaoExclusaoManutencaoVeiculo = ({ excluir, selecionaManutencaoVeiculo, manutencaoVeiculo }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoManutencaoVeiculo" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Confirmar Exclusão
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir o registro <strong>{manutencaoVeiculo ? manutencaoVeiculo.tipoOcorrencia : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                        onClick={() => selecionaManutencaoVeiculo()}>Cancelar
                    </button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--manutencao-veiculo">
        <div className="vx-list-header-cell"></div>
        <div className="vx-list-header-cell">Data Ocorrência</div>
        <div className="vx-list-header-cell">Registrado Por</div>
        <div className="vx-list-header-cell">Data Entrada</div>
        <div className="vx-list-header-cell">Tipo Ocorrência</div>
        <div className="vx-list-header-cell">Valor Total</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

export class PainelRegistrarManutencaoVeiculo extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            dataOcorrencia: null,
            veiculo: null,
        };
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros) {
            this.props.buscarVeiculo(parametros.veiculo, this.props.empresaSelecionada.id);
            this.buscarRegistrosManutencaoVeiculo(parametros.veiculo);
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
            if (parametros) {
                this.buscarRegistrosManutencaoVeiculo(parametros.veiculo);
            }
        }
    }

    executarDownload(arquivo) {
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(new Blob(['﻿', arquivo], { type: 'text/csv;charset=utf-8' }));
        a.download = `Dados - Manutencoes do Veiculo ${this.props.veiculo.id} - ${this.props.veiculo.descricao}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarTabelaReservasRepasse() {
        let arquivo = 'Descricao Veículo;Data Entrada;Registrado Por;Data Ocorrência;Tipo Ocorrência;Valor Total Gasto;Ocorrência\n';
        arquivo = `${arquivo}${this.props.manutencoesVeiculo.map(it => {
            const descricaoVeiculo = this.props.veiculo.descricao;
            const dataEntrada = moment(it.dataCadastro).format('DD/MM/YYYY');
            const dataOcorrencia = moment(it.dataOcorrencia).format('DD/MM/YYYY');
            const ocorrencia = `"${it.ocorrencia}"`;
            const valorTotalGasto = it.valorTotalGasto ? it.valorTotalGasto : '';
            return `${descricaoVeiculo};${dataEntrada};${it.registradoPor};${dataOcorrencia};${it.tipoOcorrencia};"${valorTotalGasto}";${ocorrencia}`;
        }).join('\n')}\n`;
        this.executarDownload(arquivo);
    }

    buscarRegistrosManutencaoVeiculo(veiculo) {
        this.props.buscarRegistrosManutencaoVeiculo(veiculo, this.props.empresaSelecionada.id, 1, 100, this.props.filtrosAdicionados);
    }

    selecionarDataOcorrencia(date) {
        this.setState({ dataOcorrencia: date || null });
    }

    excluir() {
        this.props.excluirManutencaoVeiculo(
            this.props.manutencaoVeiculoSelecionado.id,
            this.props.veiculo.id,
            this.props.empresaSelecionada.id
        ).then(() => {
            this.props.selecionaManutencaoVeiculo();
            showSuccessMsg('Registro de manutenção excluído com sucesso');
        });
    }

    limparSelecao(e) {
        e.preventDefault();
        this.limparCampos();
    }

    limparCampos() {
        this.selecionarDataOcorrencia(null);
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'tipoOcorrencia', '');
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'ocorrencia', '');
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'valorTotalGasto', '');
        this.props.selecionaManutencaoVeiculo();
    }

    montarParametros(values) {
        return {
            id: this.props.manutencaoVeiculoSelecionado.id,
            empresaId: this.props.empresaSelecionada.id,
            veiculoId: this.props.veiculo.id,
            dataOcorrencia: this.state.dataOcorrencia,
            tipoOcorrencia: values.tipoOcorrencia,
            ocorrencia: values.ocorrencia,
            valorTotalGasto: this.props.valorTotalGasto ? this.props.valorTotalGasto.replace('R$', '') : null,
        };
    }

    submit(values) {
        const parametros = this.montarParametros(values);
        if (this.props.manutencaoVeiculoSelecionado.id) {
            this.props.atualizarManutencaoVeiculo(parametros).then(() => {
                showSuccessMsg('Registro de manutenção alterado com sucesso');
                this.limparCampos();
            });
        } else {
            this.props.cadastrarManutencaoVeiculo(parametros).then(() => {
                showSuccessMsg('Registro de manutenção salvo com sucesso');
                this.limparCampos();
            });
        }
    }

    exibirInfoVeiculo() {
        const v = this.props.veiculo;
        if (!v || !v.descricao) return null;

        const infos = [
            v.placa && { icon: 'pin', label: `Placa: ${v.placa}` },
            v.modelo && { icon: 'label', label: `Modelo: ${v.modelo}` },
            v.tipoVeiculo && { icon: 'category', label: v.tipoVeiculo.valor },
            v.anoFabricacao && { icon: 'calendar_today', label: `Ano: ${v.anoFabricacao}` },
            v.quilometragem && { icon: 'speed', label: `KM: ${v.quilometragem}` },
            v.renavam && { icon: 'badge', label: `Renavam: ${v.renavam}` },
        ].filter(Boolean);

        return (
            <div style={{ background: '#f8f9fa', border: '1px solid #eee', borderLeft: '3px solid var(--vx-primary)', borderRadius: 8, padding: '12px 16px', marginBottom: 20 }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#222', marginBottom: infos.length ? 8 : 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <i className="material-icons" style={{ fontSize: 18, color: 'var(--vx-primary)' }}>directions_bus</i>
                    {v.descricao}
                </div>
                {infos.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
                        {infos.map((info, i) => (
                            <span key={i} style={{ fontSize: 12, color: '#666', display: 'flex', alignItems: 'center', gap: 4 }}>
                                <i className="material-icons" style={{ fontSize: 13, color: '#aaa' }}>{info.icon}</i>
                                {info.label}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    exibirListaManutencoes() {
        if (!this.props.manutencoesVeiculo || this.props.manutencoesVeiculo.length === 0) {
            return (
                <div className="vx-empty-state">
                    <i className="material-icons">build</i>
                    <p>Nenhum registro de manutenção encontrado.</p>
                </div>
            );
        }
        return this.props.manutencoesVeiculo.map(it => (
            <ManutencaoVeiculo
                key={`manutencao-veiculo-${it.id}`}
                manutencaoVeiculo={it}
                selecionarDataOcorrencia={this.selecionarDataOcorrencia.bind(this)}
                limparSelecaoManutencaoVeiculo={this.limparCampos.bind(this)}
            />
        ));
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;
        const ehEdicao = !!(this.props.manutencaoVeiculoSelecionado && this.props.manutencaoVeiculoSelecionado.id);

        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id),
            ]}>
                <div className="container-padrao">
                    <Titulo texto="Manutenção de Veículo" urlRetorno="/painel-veiculos" />

                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div style={{ maxWidth: 340, marginBottom: 16 }}>
                            <CampoSelecionarEmpresa />
                        </div>
                    </Autorizacao>

                    {/* Filtros */}
                    <div style={{ marginBottom: 8 }}>
                        <PainelFiltragem />
                    </div>

                    {/* Toolbar: Exportar */}
                    <div className="vx-page-toolbar" style={{ marginBottom: 16 }}>
                        <span />
                        <div className="dropdown">
                            <button className="vx-toolbar-btn dropdown-toggle" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons" style={{ fontSize: 16 }}>download</i>
                                Exportar
                            </button>
                            <div className="dropdown-menu dropdown-menu-right vx-actions-menu">
                                <button className="dropdown-item vx-action-item" type="button"
                                    onClick={() => this.exportarTabelaReservasRepasse()}>
                                    <i className="material-icons">table_chart</i> Exportar lista CSV
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Info do veículo */}
                    {this.exibirInfoVeiculo()}

                    {/* Formulário de registro */}
                    <form onSubmit={handleSubmit(this.submit)}>
                        <SectionCard
                            icon="build"
                            title={ehEdicao ? 'Editar Registro' : 'Novo Registro de Manutenção'}
                            subtitle={ehEdicao ? 'Atualize os dados do registro selecionado' : 'Preencha os dados da ocorrência'}
                        >
                            {/* Data de entrada + Registrado por (somente leitura quando há seleção) */}
                            {ehEdicao && (
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Data de Entrada:</label>
                                        <div style={{ fontSize: 13, color: '#333', padding: '6px 0' }}>
                                            {this.props.manutencaoVeiculoSelecionado.dataCadastro
                                                ? <Moment format="DD/MM/YYYY">{this.props.manutencaoVeiculoSelecionado.dataCadastro}</Moment>
                                                : <span style={{ color: '#aaa' }}>—</span>}
                                        </div>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>Registrado Por:</label>
                                        <div style={{ fontSize: 13, color: '#333', padding: '6px 0' }}>
                                            {this.props.manutencaoVeiculoSelecionado.registradoPor || <span style={{ color: '#aaa' }}>—</span>}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                {/* Data Ocorrência */}
                                <div>
                                    <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>
                                        Data da Ocorrência: <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <DatePicker
                                        className='form-control'
                                        value={this.state.dataOcorrencia}
                                        locale="pt-BR"
                                        selected={this.state.dataOcorrencia && moment(this.state.dataOcorrencia).toDate()}
                                        onChange={date => this.selecionarDataOcorrencia(date)}
                                        dateFormat="dd/MM/yyyy"
                                        customInput={<InputMask mask="99/99/9999" />}
                                    />
                                </div>

                                {/* Valor Total Gasto */}
                                <div>
                                    <Field name="valorTotalGasto"
                                        validate={[maxValueMonetario]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label='Valor Total Gasto:' />
                                </div>
                            </div>

                            {/* Tipo Ocorrência */}
                            <div style={{ marginBottom: 16 }}>
                                <Field name='tipoOcorrencia' type="text" component={renderField}
                                    validate={[required, maxTamanhoCampoTipoOcorrencia]}
                                    label='Tipo de Ocorrência:'
                                    css="form-control" readOnly={false} />
                            </div>

                            {/* Ocorrência (textarea) */}
                            <div>
                                <Field name='ocorrencia' css="form-control" component={renderTextArea}
                                    className="form-control" max={2000}
                                    label="Descrição da Ocorrência:" validate={[required]} />
                            </div>
                        </SectionCard>

                        {/* Save bar */}
                        <div className="vx-config-save-bar">
                            <span className="vx-config-save-hint">
                                <i className="material-icons">info_outline</i>
                                {!this.state.dataOcorrencia ? 'Informe a data da ocorrência para salvar' : ehEdicao ? 'Editando registro existente' : 'Novo registro de manutenção'}
                            </span>
                            <div style={{ display: 'flex', gap: 8 }}>
                                {ehEdicao && (
                                    <button type="button"
                                        className="vx-toolbar-btn vx-toolbar-btn--secondary"
                                        onClick={(e) => this.limparSelecao(e)}>
                                        <i className="material-icons" style={{ fontSize: 16 }}>close</i>
                                        Cancelar edição
                                    </button>
                                )}
                                <button type="submit"
                                    disabled={invalid || submitting || !this.state.dataOcorrencia}
                                    className="btn btn-laranja vx-config-save-btn">
                                    <i className="material-icons">save</i>
                                    {ehEdicao ? 'Salvar Alterações' : 'Registrar Manutenção'}
                                </button>
                            </div>
                        </div>
                    </form>

                    {/* Lista de manutenções */}
                    <div style={{ marginTop: 24 }}>
                        <div style={{ fontWeight: 700, fontSize: 13, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                            <i className="material-icons" style={{ fontSize: 16, color: 'var(--vx-primary)' }}>history</i>
                            Histórico de Manutenções
                        </div>
                        {this.props.manutencoesVeiculo && this.props.manutencoesVeiculo.length > 0 && <CabecalhoTabela />}
                        <div className="vx-list-container">
                            {this.exibirListaManutencoes()}
                        </div>
                    </div>
                </div>

                <ModalConfirmacaoExclusaoManutencaoVeiculo
                    excluir={this.excluir.bind(this)}
                    selecionaManutencaoVeiculo={this.props.selecionaManutencaoVeiculo.bind(this)}
                    manutencaoVeiculo={this.props.manutencaoVeiculoSelecionado}
                />
            </Autorizacao>
        );
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    veiculo: state.veiculo,
    manutencoesVeiculo: state.manutencoesVeiculo.manutencoesVeiculo,
    manutencaoVeiculoSelecionado: state.manutencoesVeiculo.manutencaoVeiculoSelecionado,
    filtrosAdicionados: state.filtrosAdicionadosManutencaoVeiculo,
    valorTotalGasto: formValueSelector('formularioPainelRegistroManutencaoVeiculo')(state, 'valorTotalGasto'),
});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        buscarVeiculo,
        cadastrarManutencaoVeiculo,
        atualizarManutencaoVeiculo,
        buscarRegistrosManutencaoVeiculo,
        selecionaManutencaoVeiculo,
        excluirManutencaoVeiculo,
    }, dispatch)
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelRegistroManutencaoVeiculo',
    validate,
})(PainelRegistrarManutencaoVeiculo)));
